import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import TrafficSourceForm from '@/components/TrafficSource/TrafficSourceForm/TrafficSourceForm.vue';
import ITrafficSource from '@/interfaces/ITrafficSource';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component({
    name: 'TrafficSourceCreate',
    components: {
        Loader,
        CardHeader,
        TrafficSourceForm
    }
})
export default class TrafficSourceCreate extends Vue {
    @Action private createTrafficSource!: (form: ITrafficSource) => Promise<void>;

    private trafficSourceData: ITrafficSource = {
        title: '',
        maxClickIdLength: 0,
    };

    private loading: boolean = true;

    private isEdit: boolean = true;

    private trafficSourceCreate(form: ITrafficSource) {
        try{
            this.createTrafficSource(form);
        } catch(error) {
            console.error(error)
        }
    }

    private mounted() {
        try {
            this.loading = false;
        } catch {
            return void 0;
        }
    }
};